<div
  class="flex flex-col items-start gap-4 p-4 self-stretch rounded-[8px] border border-neutrals-300 bg-white w-full mb-2"
>
  <div class="flex flex-col gap-1 self-stretch items-start">
    <ui-paragraph
      class="bg-neutrals-300 py-[2px] px-[6px] rounded-[4px]"
      type="p10"
      mobile-type="p10"
      font-weight="bold"
      text-color="neutrals-900"
      [content]="'N° PEDIDO: ' + order.orderNumber"
    />
    <ui-headline
      type="h16"
      mobile-type="h16"
      text-color="neutrals-900"
      font-weight="semibold"
      [content]="order.commercialName"
    />
  </div>
  <div class="flex flex-col gap-1 w-full">
    <digicem-product-accordion
      *ngFor="let product of order.products; let i = index"
      [title]="getTitleProduct(i)"
      [productName]="product.productName"
      [quantityText]="getQuantityProduct(product)"
    ></digicem-product-accordion>
    <div
      class="flex items-center justify-between pr-2 py-2 pl-3 self-stretch rounded-[4px] border border-neutrals-300 bg-neutrals-100 w-full gap-3"
    >
      <ui-paragraph
        type="p10"
        mobile-type="p10"
        text-color="neutrals-700"
        font-weight="medium"
        content="Dirección:"
      />
      <div class="flex items-center gap-2">
        <ui-paragraph
          class="text-end leading-tight"
          type="p10"
          mobile-type="p10"
          text-color="neutrals-900"
          font-weight="semibold"
          [content]="getAddress()"
        />
        <button
          class="flex items-center gap-1 px-[6px] py-2 rounded-lg transition-colors duration-300"
          [ngClass]="{
            'bg-primary-100': !copied,
            'bg-neutrals-300 cursor-not-allowed': copied,
          }"
          [disabled]="copied"
          (click)="copy()"
        >
          <ui-paragraph
            type="p10"
            mobile-type="p10"
            [attr.text-color]="copied ? 'neutrals-600' : 'primary-500'"
            font-weight="bold"
            [content]="copied ? 'Copiado' : 'COPIAR'"
          />
        </button>
      </div>
    </div>
    <div
      *ngIf="order.shippingStartDateTime"
      class="flex items-center justify-between pr-2 py-2 pl-3 self-stretch rounded-[4px] border border-neutrals-300 bg-neutrals-100 w-full gap-3"
    >
      <ui-paragraph
        type="p10"
        mobile-type="p10"
        text-color="neutrals-700"
        font-weight="medium"
        content="Fecha de entrega:"
      />
      <ui-paragraph
        class="text-end leading-tight"
        type="p10"
        mobile-type="p10"
        text-color="neutrals-900"
        font-weight="semibold"
        [content]="order.shippingStartDateTime | date: 'dd/MM/yyyy'"
      />
    </div>
  </div>
  <div class="flex gap-1 w-full" *ngIf="!isDelivered">
    <ui-button
      class="flex-1"
      type="primary"
      responsive="false"
      size="sm"
      button-text="Ingresar código"
      (clicked)="onEnterCode()"
    ></ui-button>
    <digicem-camera-button
      class="flex-1"
      (fileSelected)="onFileSelected($any($event))"
    ></digicem-camera-button>
  </div>
  <div class="flex gap-1 items-stretch w-full" *ngIf="isDelivered">
    <ui-button
      class="w-full"
      type="primary"
      responsive="false"
      size="sm"
      button-text="Validado"
      [enabled]="false"
    ></ui-button>
    <div *ngIf="photoUrl" class="relative w-8 h-8">
      <img
        [src]="photoUrl"
        alt="OrderPhoto"
        class="w-8 h-8 object-cover rounded"
      />
      <div
        class="absolute bottom-2 right-[-8px] bg-success-100 rounded-full w-4 h-4 p-[1px]"
      >
        <ui-icon
          name="check-filled"
          size="14"
          mobile-size="14"
          fill="success-300"
        ></ui-icon>
      </div>
    </div>
  </div>
</div>
